import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { useBasketTotals, useDeviceSize } from '@hooks';
import { Routes } from '@enums';
import { DrawerComponent } from '@components/drawer/drawer.component';
import { PriceDisplay } from '@components/price-display';
import { StyledHeaderTypography } from '@components/swipeable-drawer/swipeable-drawer.styles';
import { Icon, IconButton } from '@elements';
import { StyledBox, StyledButton, StyledLink, StyledTypography } from './basket.styles';
import up from '@images/chevron-up.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var BasketComponent = function BasketComponent(_ref) {
  var basket = _ref.basket;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useDeviceSize = useDeviceSize(),
      mobile = _useDeviceSize.mobile,
      tablet = _useDeviceSize.tablet;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var navigate = useNavigate();
  var totals = useBasketTotals();
  var size = basket.reduce(function (acc, item) {
    return acc + item.quantity;
  }, 0);

  var toggleDrawer = function toggleDrawer() {
    setOpen(function (prev) {
      return !prev;
    });
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: mobile || tablet ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs(StyledBox, {
        open: false,
        mobile: mobile || tablet,
        flexDirection: "column",
        children: [/*#__PURE__*/_jsxs(Box, {
          display: "flex",
          flexDirection: "column",
          pt: 1.5,
          pb: 2.5,
          gap: 2,
          width: "100%",
          children: [/*#__PURE__*/_jsxs(Box, {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            children: [/*#__PURE__*/_jsx(StyledHeaderTypography, {
              color: "secondarySilver",
              children: t('pages.basket.tickets')
            }), /*#__PURE__*/_jsx(StyledHeaderTypography, {
              color: "white",
              children: size
            })]
          }), /*#__PURE__*/_jsxs(Box, {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            children: [/*#__PURE__*/_jsx(StyledHeaderTypography, {
              color: "secondarySilver",
              children: t('pages.basket.sum')
            }), /*#__PURE__*/_jsx(PriceDisplay, {
              basePrice: totals.basketBaseTotal,
              finalPrice: totals.basketFinalTotal
            })]
          })]
        }), /*#__PURE__*/_jsx(StyledButton, {
          variant: "contained",
          fullWidth: true,
          onClick: function onClick() {
            return navigate(Routes.Basket);
          },
          children: t('pages.basket.toBasket')
        })]
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(StyledBox, {
        open: open,
        children: [!open && /*#__PURE__*/_jsx(IconButton, {
          onClick: toggleDrawer,
          sx: {
            position: 'absolute !important',
            top: '-16px',
            left: '50%',
            transform: 'translateX(-50%)'
          },
          children: /*#__PURE__*/_jsx(Icon, {
            src: up,
            width: 14,
            height: 14
          })
        }), /*#__PURE__*/_jsxs(Box, {
          display: "flex",
          alignItems: "center",
          gap: 2.5,
          children: [/*#__PURE__*/_jsxs(Box, {
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            children: [/*#__PURE__*/_jsx(StyledTypography, {
              color: "secondarySilver",
              children: t('pages.basket.tickets')
            }), /*#__PURE__*/_jsx(StyledTypography, {
              color: "white",
              children: size
            })]
          }), /*#__PURE__*/_jsx(StyledLink, {
            onClick: toggleDrawer,
            variant: "text",
            children: t('pages.basket.showMore')
          })]
        }), /*#__PURE__*/_jsxs(Box, {
          display: "flex",
          alignItems: "center",
          gap: 2.5,
          children: [/*#__PURE__*/_jsxs(Box, {
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            children: [/*#__PURE__*/_jsx(StyledTypography, {
              color: "secondarySilver",
              children: t('pages.basket.sum')
            }), /*#__PURE__*/_jsx(PriceDisplay, {
              basePrice: totals.basketBaseTotal,
              finalPrice: totals.basketFinalTotal
            })]
          }), /*#__PURE__*/_jsx(StyledButton, {
            variant: "contained",
            onClick: function onClick() {
              return navigate(Routes.Basket);
            },
            children: t('pages.basket.toBasket')
          })]
        })]
      }), /*#__PURE__*/_jsx(DrawerComponent, {
        open: open,
        toggleDrawer: toggleDrawer,
        basket: basket
      })]
    })
  });
};

export { BasketComponent };